<template>
  <div class="dnd-page">
    <div class="flex-grid-thirds">
      <div class="sml-col"/>
      <div class="col">
        <DndCharacterGenerator />
        <h1>Wait. What Is This??</h1>
        <p>In an effort to become even <i>more</i> of a nerd I decided I should spend some free time attempting to generate DND name, race and class combos using machine learning. Then as a bonus also generate a bio for that character.</p>
        <p>
          The names were generated using GPT2's publically available small parameter model with Max Woolf's <a href="https://github.com/minimaxir/gpt-2-simple" target="_blank">gpt2-simple</a>. 
          The model was finetuned on crowdsourced data collected by Janelle Shane at <a href="https://github.com/janelleshane/DnD-characters" target="_blank">AI Weirdness</a>. 
        </p>
        <p>
          The character bios are generated in the browser using <a href="https://ml5js.org/" target="_blank">ml5.js</a> and the <a href="https://learn.ml5js.org/#/reference/charrnn" target="_blank">charRNN</a> model.
          The generation is done with a model trained on yet more crowdsourced DND data from <a href="https://github.com/janelleshane/DnD_bios" target="_blank">AI Weirdness</a>. 
          The pre-generated character name, race and class combo is used as a seed for a stateless generation attempt by charRNN, the result is presented as the character bio. 
        </p>
        <p>I also used some lovely <a href="https://thenounproject.com/term/d20-dice/763027/" target="_blank">D20</a> and <a href="https://thenounproject.com/search/?q=goblin&i=1005190" target="_blank">goblin</a> icons from creators at the <a href="https://thenounproject.com/" target="_blank">noun project</a>.</p>
      </div>
      <div class="sml-col"></div>
    </div>
  </div>
</template>

<script>
  import DndCharacterGenerator from '../components/DndCharacterGenerator'
  export default {
    name: 'DndPage',
    components: {
      DndCharacterGenerator
    }
  }
</script>
<style scoped>
  .dnd-page {
    text-align: center;
    font-size: 16px;
  }

  h1 {
    font-size: 2em;
    color: black;
    font-family: 'Press Start 2P', cursive;
    padding-top: 2em;
    /* border-top: 1px solid black; */
  }

   .flex-grid {
  display: flex;
  }
  .col {
    flex: 1;
  }

  .flex-grid-thirds {
    display: flex;
    justify-content: space-between;
  }

  .flex-grid-thirds .col {
    width: 40%;
  }

  .flex-grid-thirds .sml-col {
    width: 10%;
    text-align: left;
  }
</style>
